<template>
  <div class="container">
    <h3 class="title is-3 has-text-centered">
      Request a new Confirmation email
    </h3>
    <div class="columns is-centered">
      <div class="column is-one-third">
        <div
          class="notification is-info"
          :class="{
            'is-info': confirm,
            'is-danger': error
          }"
          v-if="confirm || error"
        >
          <p v-if="confirm">
            An new confirmation email has been sent to your account. Please
            check your <strong>Spam</strong> folder and mark it as
            <strong>Safe</strong> if you don't find the email in your inbox.
          </p>
          <p v-if="error">
            {{ error }}
          </p>
        </div>
        <form
          v-if="!confirm"
          id="confirmForm"
          @submit="submitForm($event)"
          novalidate
        >
          <div class="field">
            <label for="email" class="label">
              Just input the email address you used to create your account and
              we'll send you a new confirmation email!
            </label>
            <div class="control has-icons-left">
              <input
                id="email"
                required="required"
                name="email"
                placeholder="john.doe@example.com"
                class="input"
                :class="{ 'is-danger': !email.valid }"
                type="email"
                v-model="account"
              />
              <span class="icon is-small is-left">
                <i class="fas fa-envelope"></i>
              </span>
            </div>
            <p class="help" :class="{ 'is-danger': !email.valid }">
              {{ email.errorMessage }}
            </p>
          </div>
          <div class="field">
            <button
              type="submit"
              class="button is-fullwidth is-primary text-capitalize"
            >
              Send!
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      confirm: false,
      email: {
        valid: true,
        errorMessage: ''
      },
      account: '',
      error: ''
    };
  },
  methods: {
    submitForm(evt) {
      evt.preventDefault();
      let form = this.$el.querySelector('#confirmForm');
      let fields = [
        {
          field: this.$el.querySelector('#email'),
          validation: this.email
        }
      ];
      if (form.checkValidity()) {
        this.$axios
          .post(this.$API.requestConfirmation(), { email: this.account })
          .then(() => {
            this.confirm = true;
            this.error = '';
            setTimeout(() => this.$router.push({ path: '/' }), 5000);
          })
          .catch(err => {
            console.info('Error: ', err);
            this.error = err.response.data.message;
          });
      } else {
        fields[0].validation.valid = fields[0].field.checkValidity();
        fields[0].validation.errorMessage = fields[0].field.validationMessage;
      }
    }
  }
};
</script>
